import {BaseContainerModel} from '../../base-container.model';
import { bl_aat_claim_document_line_RowClass} from '../../../dbschema';

export class MyClaimDocumentLineContainerModel extends BaseContainerModel {
  bl_aat_claim_document_line: bl_aat_claim_document_line_RowClass = new bl_aat_claim_document_line_RowClass();
}

export class ClaimDocumentLineSplitContainerModel extends BaseContainerModel {
  current_claim_line: MyClaimDocumentLineContainerModel;
  split_claim_lines: MyClaimDocumentLineContainerModel[];
}
